import { FieldModel } from '@cibo/core'
import { CashCropCellDisplay } from '@cibo/landmanager'
import { TraitCellContainer } from './TraitCellContainer'

interface CashCropCellProps {
  value: any
  task: any
  year: number
  selectedField: FieldModel | null
}

export const CashCropCell = ({ value, task, year, selectedField }: CashCropCellProps) => {
  return (
    <TraitCellContainer
      value={value}
      task={task}
      selectedField={selectedField}
      year={year}
      traitId="cashCrop"
    >
      <CashCropCellDisplay value={value} />
    </TraitCellContainer>
  )
}
